/**
 * Provides the wrapper elements for creating a modal window. This function uses
 * micromodal.
 *
 * @param {string} content Content that goes in the modal window.
 * @param {string} id A unique ID to identify this modal window.
 * @param {string} class_name A custom class that can be used to customize the style of the modal.
 */
const modal_template = (content, id, class_name = '') => {
	return `<div class="modal micromodal-slide ${class_name}" id="${id}" aria-hidden="true">
		<div class="modal__overlay" tabindex="-1" data-micromodal-close>
			<div class="modal__container" role="dialog" aria-modal="true" aria-labelledby="${id}-title">
				<button class="modal__close" aria-label="Close modal" data-micromodal-close></button>

				<main class="modal__content" id="${id}-content">
					${content}
				</main>

				<button class="button secondary text-center modal__close-button" aria-label="Close modal" data-micromodal-close>Close Window</button>
			</div>
		</div>
	</div>`
}

export { modal_template }
